module.exports = __webpack_public_path__ + "1c724f0a29e16be0a7c7e25f3e0413aa.svg";